export const MessageCodes = Object.freeze({
  PartnerSynchronization: "PartnerSynchronization"
});
